import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import ChevronLeftIcon from 'components/material-symbol/icons/ChevronLeft'
import ChevronRightIcon from 'components/material-symbol/icons/ChevronRight'
import EventIcon from 'components/material-symbol/icons/Event'
import { makeStyles } from '@material-ui/core/styles'
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers'
import CustomLuxonAdapter from 'lib/CustomLuxonAdapter'
import { formatWeekLabel } from './utils'

const useStyles = makeStyles(theme => ({
  jumpButton: {
    fontWeight: 500,
    fontSize: '1rem',
    textTransform: 'none',
    color: theme.palette.text.primary,
    padding: theme.spacing(0.5, 1),
  },
}))

const hiddenPickerStyle = { display: 'none' }

const WeekNavigator = ({ weekRange, onPrev, onNext, onJumpToDate }) => {
  const classes = useStyles()
  const [pickerOpen, setPickerOpen] = useState(false)

  const handleAccept = picked => {
    if (picked && onJumpToDate) onJumpToDate(picked)
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={2}
      py={1}
    >
      <IconButton aria-label="previous week" size="small" onClick={onPrev}>
        <ChevronLeftIcon />
      </IconButton>
      <Box flex={1} textAlign="center">
        <Button
          className={classes.jumpButton}
          startIcon={<EventIcon fontSize="small" />}
          onClick={() => setPickerOpen(true)}
          aria-label="Jump to week"
        >
          {formatWeekLabel(weekRange)}
        </Button>
        <Box style={hiddenPickerStyle} aria-hidden>
          <LocalizationProvider dateAdapter={CustomLuxonAdapter} locale="en-us">
            <MobileDatePicker
              open={pickerOpen}
              value={weekRange.start}
              onClose={() => setPickerOpen(false)}
              onAccept={handleAccept}
              format="MMM d, yyyy"
            />
          </LocalizationProvider>
        </Box>
      </Box>
      <IconButton aria-label="next week" size="small" onClick={onNext}>
        <ChevronRightIcon />
      </IconButton>
    </Box>
  )
}

export default WeekNavigator
